require('./bootstrap');
import { Modal } from 'bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles

AOS.init({
  disable: false,
  easing: 'ease-out-back'
});

const loaderSpinner = document.getElementById('loader-spinner');
const loader = new Modal(loaderSpinner, {
  keyboard: false
});

// Example starter JavaScript for disabling form submissions if there are invalid fields
(function () {
  'use strict'

  // Fetch all the forms we want to apply custom Bootstrap validation styles to
  var forms = document.querySelectorAll('.needs-validation')

  // Loop over them and prevent submission
  Array.prototype.slice.call(forms)
    .forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (!form.checkValidity()) {
          form.classList.add('form-invalid');
          setTimeout(() => {
            form.classList.remove('form-invalid');
          }, 820);
        } else {
          loader.show();
          form.submit();
        }

        form.classList.add('was-validated')
      }, false)
    })
})()